import { useState, useEffect, useRef } from 'react'
import { useIsMutating, useIsFetching } from '@tanstack/react-query'
import { useNeedsUpload } from '../contexts/EditorContent/hooks'

function CloudLoading() {
  const [cloudState, setCloudState] = useState('default')
  const isMutating = useIsMutating()
  const isFetching = useIsFetching()
  const needsUpload = useNeedsUpload()
  const didStartFetching = useRef<boolean>(false)

  useEffect(() => {
    // Once the fetching started, we show the loading dialog, block other states that come in
    // till the loading is done
    if (didStartFetching.current) {
      return
    }

    if (isMutating || isFetching) {
      didStartFetching.current = true
      setCloudState('loading')
    } else if (needsUpload) {
      // NeedsUpload is true when the user has made changes to the note.
      // It can be set to false when the user reverses the change so an upload is unecessary
      setCloudState('default')
    } else {
      setCloudState('done-loading')
    }
  }, [isMutating, isFetching, needsUpload, cloudState])

  useEffect(() => {
    if (cloudState === 'loading') {
      setTimeout(() => {
        didStartFetching.current = false
        setCloudState('done-loading')
      }, 1000)
    }
  }, [cloudState])
  return (
    <div className='mr-2 flex w-10 items-center'>
      {cloudState === 'default' && (
        <div className=''>
          {isMutating > 0 && (
            <i className='font-variant-numeric flex h-4 w-4 -rotate-12 transform items-center justify-center rounded-full bg-gray-300 text-xs font-normal text-gray-900'>
              {isMutating}
            </i>
          )}
        </div>
      )}

      <button className='bg-transparent'>
        <div className='absolute contents'>
          {cloudState === 'default' && (
            <i className='fa-solid fa-cloud fa-md'></i>
          )}
          {cloudState === 'loading' && (
            <div className='relative flex w-8 items-center justify-center'>
              <i className='fa-regular fa-spinner-third fa-spin fa-xl absolute'></i>
              <i className='fa-solid fa-cloud fa-xs absolute'></i>
            </div>
          )}
          {cloudState === 'done-loading' && (
            <i className='fa-solid fa-cloud-check fa-md w-8'></i>
          )}
        </div>
      </button>
    </div>
  )
}

export default CloudLoading
